import { chosenSites } from "app/common/services/chosenSites";

export type TranslationReplacement = string | number;
export type TranslationReplacements<V = TranslationReplacement> = Partial<Record<string, V>>;

export type Translate = (
    key: string | string[],
    replacements?: Readonly<TranslationReplacements>,
    defaultValue?: string,
) => string;

function translate(key: string | string[], obj = {}, defaultValue: string = Array.isArray(key) ? key[0] : key) {
    const replacements: Record<string, () => string> = {
        site: () => chosenSites.getPrimarySite()?.name ?? "",
    };

    const replacementKeys = Object.keys(replacements);

    if (!key) {
        return "";
    }

    let res: string | undefined;
    try {
        const i18n = window.i18n;
        res = i18n?.t ? i18n.t(key, obj) : defaultValue;
    } catch (_e) {
        console.log("i18nFilter - error trying to translate", key, obj);
    }

    replacementKeys.forEach((replacement) => {
        const searchString = `%${replacement}%`;

        if (res && res.indexOf(searchString) > -1) {
            res = res.replace(searchString, replacements[replacement]());
        }
    });

    return res || defaultValue;
}

function i18nFilter(): Translate {
    return translate;
}

function getI18nParams() {
    const i18n = window.i18n;
    return {
        baseUrl: i18n?.baseUrl,
        env: i18n?.env,
        locale: i18n?.getLocale?.(),
    };
}

export { translate, i18nFilter, getI18nParams };
